<div class="not-supported__container">
  <img class="not-supported__image" src="../../../assets/images/warning.svg">
  <div class="not-supported__body">
    <span class="not-supported__title">Your browser is not supported.</span>
    <span class="not-supported__description">Please use another browser such as <a href="https://www.google.com/chrome/">Chrome</a>,
      <a href="https://www.mozilla.org/firefox">Firefox</a> or
      <a href="https://www.apple.com/safari/">Safari</a>.</span>
  </div>
</div>
